/** Wallet checks before on-chain DAO dispute resolution. */

export function normalizeWalletAddress(value) {
  return String(value || '').trim().toLowerCase();
}

export function getAccountWalletAddress(user) {
  return normalizeWalletAddress(user?.walletAddress || user?.connectedWalletAddress);
}

/** Require connected wallet matches logged-in Workloob account. */
export async function assertDaoMemberWalletForOnChain({ user, isConnected, walletAddress, connectWallet }) {
  if (!isConnected || !walletAddress) {
    if (typeof connectWallet === 'function') {
      const result = await connectWallet();
      if (result?.address) {
        walletAddress = result.address;
      }
    }
  }
  const connected = normalizeWalletAddress(walletAddress);
  if (!connected) {
    throw new Error('Connect your wallet before resolving this dispute on-chain');
  }
  const account = getAccountWalletAddress(user);
  if (!account) {
    throw new Error('Link a wallet to your Workloob account before on-chain dispute resolution');
  }
  if (connected !== account) {
    throw new Error('Connected wallet must match your account wallet');
  }
  return connected;
}
